import { useThemeStore } from "../stores/theme.store.js";
import { useCalendarsStore } from "../stores/calendars.store.js";
import { useTopicsStore } from "../stores/topics.store.js";
import { resolvedTaskContextColor } from "./entity-colors.js";
export { CAL_PALETTE_OFFSET } from "./entity-colors.js";

/** Resolves the "context color" for a task from the active THEME: selected topic
 *  colors (override or categorical-palette default) mix together, then the
 *  calendar (override, or — when auto-color is on — a categorical default), then
 *  the kind/global override, then a themed default so no entry is ever bare.
 *
 *  Pass the result as `contextColor` to `washStyle` / `effectiveColorOf` so it
 *  becomes the default fill when `custom_color` is null. */
export function useTaskContextColor(task: { calendar_id: string | null; topic_ids: string[]; is_event?: boolean }): string | null {
  const topics = useTopicsStore((s) => s.topics);
  const calendars = useCalendarsStore((s) => s.calendars);
  const theme = useThemeStore((s) => s.config);
  return resolvedTaskContextColor(theme, topics, calendars, task);
}
